import React from 'react';
import { Link } from 'react-router-dom';

export const fmtDate = (d) => new Date(String(d).replace(' ', 'T') + 'Z')
  .toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' });

const plural = (n, word) => `${n} ${word}${n > 1 ? 's' : ''}`;

// Les sujets en cartes (page Notes et page admin/notes) : un clic ouvre la liste des dissertations du sujet
export function SubjectCards({ subjects, base }) {
  return (
    <div className="qcm-subject-grid">
      {subjects.map((s, i) => {
        const n = s.count != null ? s.count : s.note_count;
        return (
          <Link key={s.id} to={`${base}/sujet/${s.id}`} className={`qcm-subject-card notes-card tone-${i % 4}`}>
            <span className="qcm-subject-card-count">{plural(n, 'dissertation')}</span>
            <h3>{s.name}</h3>
            {s.description && <p>{s.description}</p>}
            <span className="qcm-subject-card-go">voir les dissertations →</span>
          </Link>
        );
      })}
    </div>
  );
}

// Une dissertation dans la liste : titre, début du texte (2 lignes), « lire plus ».
// showEdit (administrateur connecté) : bouton « modifier » à côté de « lire plus ».
export function NoteRow({ n, showEdit, onDelete }) {
  const draft = n.published === 0 || n.published === false;
  return (
    <li className="note-item">
      <div className="note-item-meta">
        <span>{fmtDate(n.created_at)}</span>
        {draft && <span className="note-draft">⏸ brouillon</span>}
      </div>
      <h3><Link to={`/notes/${n.slug}`}>{n.title}</Link></h3>
      {n.excerpt && <p className="note-item-excerpt">{n.excerpt}</p>}
      {n.snippet && <p className="search-snippet">« {n.snippet} »</p>}
      <div className="note-item-actions">
        <Link to={`/notes/${n.slug}`} className="note-readmore" aria-label={`Lire plus : ${n.title}`}>lire plus →</Link>
        {showEdit && <Link to={`/admin/notes/${n.id}`} className="btn secondary note-edit">modifier</Link>}
        {showEdit && onDelete && <button type="button" className="btn danger note-edit" onClick={() => onDelete(n)}>supprimer</button>}
      </div>
    </li>
  );
}
